// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".start-image[data-v-0804e193]{width:100%;-o-object-fit:contain;object-fit:contain}.text-area[data-v-0804e193]{padding:30px 40px}.start-text[data-v-0804e193]{color:var(--quiz-text-color);margin:25px 0}.button-area[data-v-0804e193]{text-align:center;margin-top:25px}", ""]);
// Exports
module.exports = exports;
